import { useState } from 'react';

export default function useLocalStorage<T>(key: string, defaultValue?: T) {
  const [storedValue, setStoredValue] = useState<T | undefined>(() => {
    const val = window.localStorage?.getItem(key);
    return val ? JSON.parse(val) : defaultValue;
  });

  const setValue = (value?: T) => {
    setStoredValue(value);

    if (value === undefined) {
      window.localStorage?.removeItem(key);
    } else {
      window.localStorage?.setItem(key, JSON.stringify(value));
    }
  };

  return [storedValue, setValue] as const;
}
